import moment from "moment";
import { Document, FileForm } from "./document";

export const StatusValues = ['approved', 'supplier-approved', 'approved-comments', 'canceled', 'checked', 'reserved',
                             'declined-comments', 'supplier-declined', 'published', 'supplier-published', 'ready-for-agile', 
                             'ready-for-publishing', 'saved', 'uploaded', 'supplier-uploaded', 'waiting', 'partner-reserved'
] as const;
export type StatusEnum = (typeof StatusValues)[number];


export class Status {
    category: 'Customer' | 'Supplier'
    id?: number
    name?: StatusEnum
    description?: string
    agileCode?: number
    icon?: string
    color?: string
    comment?: string
    internalStatus: boolean
    date?: Date

    constructor(object?: any){
        if(object){
            this.id = object.statusId;
            this.description = object.statusName;           
            this.category = object.category;
            this.internalStatus = object.internalStatus;
            this.agileCode = object.agileStatus;
            switch(this.description){
                case 'Approved': {
                    this.name = 'approved';
                    this.icon = 'CircleFill';
                    this.color = '#04970D';
                    break;
                }
                case 'Supplier approved': {
                    this.name = 'supplier-approved';
                    this.icon = 'CircleFill';
                    this.color = '#04970D';
                    break;
                }
                case 'Approved with comments': {
                    this.name = 'approved-comments';
                    this.icon = 'CommentAdd';
                    this.color = '#04970D';
                    break;
                }
                case 'Canceled': {//999
                    this.name = 'canceled';
                    this.icon = 'Cancel';
                    this.color = '#A30505';
                    break;
                }
                case 'Checked': {
                    this.name = 'checked';
                    this.description = 'Checked';
                    this.icon = 'CompletedSolid';
                    this.color = '#0522A3';
                    break;
                }
                case 'Declined with comments': {
                    this.name = 'declined-comments';
                    this.icon = 'CommentUrgent';
                    this.color = '#A30505';
                    break;
                }
                case 'Supplier declined': {
                    this.name = 'supplier-declined';
                    this.icon = 'CommentUrgent';
                    this.color = '#A30505';
                    break;
                }
                case 'Published': {
                    this.name = 'published';
                    this.icon = 'Completed';
                    this.color = '#0522A3';
                    break;
                }
                case 'Supplier published': {
                    this.name = 'supplier-published';
                    this.icon = 'Completed';
                    this.color = '#0522A3';
                    break;
                }
                case 'Ready for Agile': {
                    this.name = 'ready-for-agile';
                    this.icon = 'LikeSolid';
                    this.color = '#BBC105';
                    break;
                }
                case 'Ready for publishing': {
                    this.name = 'ready-for-publishing';
                    this.icon = 'LikeSolid';
                    this.color = '#04970D';
                    break;
                }
                case 'Saved to Agile': {
                    this.name = 'saved';
                    this.icon = 'Save';
                    this.color = '#BFBFBF';
                    break;
                }
                case 'Uploaded': {
                    this.name = 'uploaded';
                    this.icon = 'CloudUpload';
                    this.color = '#0522A3';
                    break;
                }
                case 'Supplier uploaded': {
                    this.name = 'supplier-uploaded';
                    this.icon = 'CloudUpload';
                    this.color = '#0522A3';
                    break;
                }
                case 'Waiting for Agile': {
                    this.name = 'waiting';
                    this.icon = 'ProgressRingDots';
                    this.color = '#D18406';
                    break;
                }
                case 'Reserved': {
                    this.name = 'reserved';
                    this.icon = 'Permissions';
                    this.color = '#B38200';
                    break;
                }
                case 'Partner reserved': {
                    this.name = 'partner-reserved';
                    this.icon = 'Permissions';
                    this.color = '#B38200';
                    break;
                }
                default: {
                    this.description = '';
                    this.icon = '';
                    this.color = '';
                }
            }

        }
        else{
            this.category = 'Customer';
            this.internalStatus = false;
        }
        this.comment = '';
    }
}

export class StatusHistory {
    id: number
    statusId: number
    date?: Date
    statusUser: string

    constructor(object: any) {
        this.id = object.statusHistoryId;
        this.statusId = object.statusId;
        this.date = (object.date) ? moment((object.date && object.date.includes('.')) ? object.date.split('.')[0] + 'Z' : object.date).toDate() : undefined;
        this.statusUser = object.statusUser;
    }
}

export class UploadFilesForm {
    files: any[]
    total: number
    fileForm: FileForm
    documents: Document[]

    constructor(object: any) {
        this.files = object.files;
        this.total = object.total;
        this.fileForm = object.fileForm;
        this.documents = object.documents;
    }
}